export const normalizeKoreanPhoneDigits = (value?: string | number | null) => {
    let digits = String(value ?? '').replace(/\D/g, '');

    if (digits.startsWith('820')) {
        digits = digits.slice(2);
    } else if (digits.startsWith('82')) {
        digits = `0${digits.slice(2)}`;
    }

    if (digits.length === 10 && !digits.startsWith('0')) {
        digits = `0${digits}`;
    }

    return digits;
};

export const formatKoreanPhoneNumber = (value?: string | number | null, fallback = '') => {
    const digits = normalizeKoreanPhoneDigits(value);

    if (digits.length === 11) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
    }

    if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    return value ? String(value) : fallback;
};

export const formatKoreanPhoneNumberInput = (value?: string | number | null) => {
    const digits = normalizeKoreanPhoneDigits(value).slice(0, 11);

    if (digits.length <= 3) {
        return digits;
    }

    if (digits.length <= 7) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }

    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};
